import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { formatPeriodo, anyTrueCsv, formatPeriodoCsv, fastestCsv } from 'src/app/utils/periodo.util';
import { Suscripcion } from "src/app/models/suscripcion";
import { SuscripcionesService } from "src/app/services/suscripciones.service";
import { ToastrService } from "ngx-toastr";
//import { login } from "../authentication/login/login.component";
import { LoginDialogComponent } from "../broker/login-dialog/login-dialog.component";
import { CookieService } from 'ngx-cookie-service';
import { MatDialog } from '@angular/material/dialog';
import { GestorModeloDialogComponent } from "../gestor/gestor-modelo-dialog/gestor-modelo-dialog.component";
import { ConfirmDialogComponent } from '../common/confirm-dialog/confirm-dialog.component';
import { SseService } from 'src/app/services/SseService';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import {  Router } from '@angular/router';
import { TemaService } from "src/app/services/tema.services";
import { Subscription } from "rxjs";
import { ColaOrdenesService } from "src/app/services/cola-ordenes.service";
import { nombreCarteraConSufijo } from "src/app/utils/nombre-cartera.util";
import { CarteraOptimaParamsService } from "src/app/services/cartera-optima-params.service";
import { switchMap } from "rxjs/operators";

@Component({
  selector: "app-suscripciones",
  templateUrl: "./suscripciones.component.html",
  styleUrl: "./suscripciones.component.scss",
})
export class SuscripcionesComponent implements OnInit {
  listaSuscripciones: Suscripcion[];
  isLoadingSuscripciones: boolean = true;
  public isDark: boolean = false;
  theme: string;
  licencia: string;
public subTheme : Subscription;
  displayedColumns: string[] = [
    "group",
    "subcarteras",
    "horaentrada",
    "horasalida", "fecharegistro", "fechasuscripcion",
    "suscrito","broker","gestor",
    "eliminar",
  ];
  sortColumn: string | null = null;
  sortDirection: 'asc' | 'desc' | null = null;
  private sortAccessors: { [key: string]: (s: Suscripcion) => any } = {
    nombre: s => (s.nombre ?? '').toLowerCase(),
    horaentrada: s => s.horaentrada ?? '',
    horasalida: s => s.horasalida ?? '',
    fecharegistro: s => s.fecharegistro ? new Date(s.fecharegistro).getTime() : 0,
    fechasuscripcion: s => s.fechasuscripcion ? new Date(s.fechasuscripcion).getTime() : 0,
    suscrito: s => !!s.suscrito,
    broker: s => !!s.broker,
    gestor: s => !!s.gestor,
  };
  constructor(private colaOrdenesService: ColaOrdenesService,
    private cookieService: CookieService,
    public dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private suscripcionesService: SuscripcionesService,private _sseservice: SseService, 
    private toastr: ToastrService,private _cookieService: CookieService,private _router: Router,public temaservicio: TemaService,
    private carteraOptimaParamsService: CarteraOptimaParamsService,
  ) {}
  ngOnInit(): void {
    this.licencia = this._cookieService.get('auth_token');
    this.consultarSuscripciones();

    this.subTheme = this.temaservicio.valDarkTheme.subscribe({
      next: (data: any) => {
        this.isDark = data;
        this.theme = data ? 'dark-theme' : 'light-theme';
      }
    });
  }

  formatPeriodo = formatPeriodo;
  anyTrueCsv = anyTrueCsv;
  formatPeriodoCsv = formatPeriodoCsv;

  // idcarteraoptima llega como CSV alineado con idsubcarteras
  getIdCarteraOptima(suscripcion: Suscripcion, i: number): string {
    const csv = suscripcion.idcarteraoptima;
    return csv != null ? (csv.toString().split(',')[i] ?? '').trim() : '';
  }

  tieneCarteraOptima(suscripcion: Suscripcion): boolean {
    const csv = suscripcion.idcarteraoptima;
    return csv != null && csv.toString().split(',').some(id => Number(id.trim()) > 0);
  }

  // Al vincular broker, la cartera del broker toma los parámetros de la(s) cartera(s) óptima(s) de la
  // suscripción, salvo que el usuario desmarque el check del diálogo de login (marcado por defecto)
  private sincronizarCarteraBroker(suscripcion: Suscripcion) {
    const nombre = suscripcion.nombrecarterabroker;
    if (!nombre) {
      this.toastr.warning('No se encontró la cartera del broker; no se sincronizó con la cartera óptima');
      return;
    }
    let riesgoMixto = false;
    this._sseservice.apiPostNew('getCarteraByNombre', { nombre }, this.licencia).pipe(
      switchMap((data: any) => {
        if (!data?.cartera) throw new Error('Cartera de broker no encontrada: ' + nombre);
        const cartera: OptimalWallet = data.cartera;
        return this.carteraOptimaParamsService.sincronizarDesdeOptimas(cartera, suscripcion.idcarteraoptima).pipe(
          switchMap(res => {
            if (res.aplicadas === 0) throw new Error('No se pudieron cargar los parámetros de la cartera óptima');
            riesgoMixto = res.riesgoMixto;
            return this._sseservice.apiPostNew('actualizarcartera', cartera, this.licencia);
          })
        );
      })
    ).subscribe({
      next: () => {
        this.toastr.success('Cartera del broker sincronizada con su cartera óptima');
        if (riesgoMixto) {
          this.toastr.warning('Las subcarteras tienen distinto riesgo; se mantiene el riesgo actual de la cartera');
        }
      },
      error: (err) => {
        console.error('Error sincronizando cartera óptima', err);
        this.toastr.error('Ocurrió un error sincronizando la cartera del broker con la cartera óptima');
      }
    });
  }

  consultarSuscripciones(onLoaded?: () => void) {
    this.suscripcionesService.listarSuscripciones().subscribe({
      next: (value) => {
        this.listaSuscripciones = value;
        this.aplicarOrden();
        this.isLoadingSuscripciones = false;
        this.cd.markForCheck();
        onLoaded?.();
      },
      error: (err) => {
        this.isLoadingSuscripciones = false;
        this.toastr.error("Ocurrió un error consultando suscripciones");
      },
    });
  }

  ordenarPor(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : this.sortDirection === 'desc' ? null : 'asc';
      if (this.sortDirection === null) {
        this.sortColumn = null;
      }
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.aplicarOrden();
  }

  getSortIcon(column: string): string {
    if (this.sortColumn !== column) {
      return 'unfold_more';
    }
    return this.sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward';
  }

  private aplicarOrden() {
    if (!this.listaSuscripciones || !this.sortColumn) {
      return;
    }
    const accessor = this.sortAccessors[this.sortColumn];
    const dir = this.sortDirection === 'desc' ? -1 : 1;
    this.listaSuscripciones = [...this.listaSuscripciones].sort((a, b) => {
      const va = accessor(a);
      const vb = accessor(b);
      if (va < vb) return -1 * dir;
      if (va > vb) return 1 * dir;
      return 0;
    });
  }

  suscribirModelo(suscribirse: boolean, suscripcion: Suscripcion) {
    if (suscribirse && !suscripcion.idsuscripcion) {
      this.registrarSuscripcion(suscripcion);
    } else if (!suscribirse && suscripcion.idsuscripcion) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '380px',
        panelClass: this.theme,
        data: {
          titulo: 'Cancelar suscripción',
          msj: 'Si cancelas la suscripción, se perderá la fecha de suscripción actual: al volver a suscribirte se registrará como una suscripción nueva, con la fecha de hoy.',
          botonAceptar: 'Sí, cancelar suscripción',
          botonCancelar: 'Volver',
          destructivo: true,
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.eliminarSuscripcion(suscripcion);
        } else {
          suscripcion.suscrito = true;
          this.cd.markForCheck();
        }
      });
    } else {
      this.toastr.error("No se pudo completar la acción");
    }
  }

  registrarSuscripcion(suscripcion: Suscripcion) {
    this.suscripcionesService.registrarSuscripcion(suscripcion).subscribe({
      next: (value: Suscripcion) => {
        let sus = this.listaSuscripciones.find(
          (s) =>
            s.idcartera == suscripcion.idcartera &&
            s.idmodelo == suscripcion.idmodelo
        );
        if (sus) {
          sus.idsuscripcion = value.idsuscripcion;
        }
        this.toastr.success("Suscripción exitosa");
        this.cd.markForCheck();
      },
      error: (err) => {
        this.toastr.error("Ocurrió un error registrando la suscripción");
      },
    });
  }
  enviarBroker(suscribirse: boolean, suscripcion: Suscripcion){
    let auth = this._cookieService.get('auth_token');
    console.log(suscripcion);
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    if (suscribirse){
    const cuentasBrokerSuscritas = this.listaSuscripciones
      .filter(s => s.broker === true && s.nombrecarterabroker && s.idcartera !== suscripcion.idcartera)
      .map(s => String(s.nombrecarterabroker));
    // El check del diálogo modifica este objeto; se lee al cerrarlo
    const opcionesVinculo = this.tieneCarteraOptima(suscripcion) ? { sincronizarOptima: true } : null;
    const dialogRef = this.dialog.open(LoginDialogComponent, {
        width: '800px',
        height: '600px',
        panelClass: dialogClass,
        data: {
            idModelo: suscripcion.idmodelo, token:auth, idCartera:suscripcion.idcartera, suscribirseForm:true, metaApi: anyTrueCsv(suscripcion.metaApi), periodo: Number(fastestCsv(suscripcion.periodo)), cuentasBrokerSuscritas, opcionesVinculo
          }
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log('El diálogo se cerró');
        // Recarga para tener nombrecarterabroker de la cuenta recién vinculada
        this.consultarSuscripciones(() => {
          if (!result || !opcionesVinculo?.sincronizarOptima) return;
          const actual = this.listaSuscripciones.find(s => s.idcartera == suscripcion.idcartera && s.broker);
          if (actual) this.sincronizarCarteraBroker(actual);
        });
        this._cookieService.delete('auto' + suscripcion.idcartera);
      });
    }else{// !suscribirse
      this.suscripcionesService.eliminarSuscripcionBroker(suscripcion).subscribe({
        next: (value: Suscripcion) => {
          let sus = this.listaSuscripciones.find(
            (s) =>
              s.idcartera == suscripcion.idcartera && s.idmodelo == suscripcion.idmodelo
          );
          if (sus) {
            sus.idsuscripcion = value.idsuscripcion;
          }
          // la cartera que se tiene abierta en broker se debe recargar
          //this._router.navigate(['/broker']);
          this.toastr.success("Desuscripción exitosa");
          this.cd.markForCheck();
        },
        error: (err) => {
          this.toastr.error("Ocurrió un error registrando la suscripción");
        },
      });
      console.log('eliminar cookie');
      console.log(suscripcion);
      this._cookieService.delete('auto' + suscripcion.idcartera);
      this.colaOrdenesService.clearLocalStorageForCartera(suscripcion.idcartera);
    }
/** 
    this.suscripcionesService.registrarSuscripcion(suscripcion).subscribe({
      next: (value: Suscripcion) => {
        let sus = this.listaSuscripciones.find(
          (s) =>
            s.idcartera == suscripcion.idcartera &&
            s.idmodelo == suscripcion.idmodelo
        );
        if (sus) {
          sus.idsuscripcion = value.idsuscripcion;
        }
        this.toastr.success("Suscripción exitosa");
        this.cd.markForCheck();
      },
      error: (err) => {
        this.toastr.error("Ocurrió un error registrando la suscripción");
      },
    });**/

}


enviarGestor(suscribirse: boolean, suscripcion: Suscripcion){
  let auth = this._cookieService.get('auth_token');
  console.log(suscripcion); 
  const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
  if(suscribirse){
    
    /**const dialogRef = this.dialog.open(GestorModeloDialogComponent, {
      width: '400px', // Ancho del diálogo
      height: '300px', // Altura del diálogo
      panelClass: dialogClass,
      data: {
          idModelo: suscripcion.idmodelo, token:auth, idCartera: suscripcion.idcartera
        }
    });**/

    let nombrecartera = nombreCarteraConSufijo(suscripcion.nombre, '-G');

    // Crear una nueva cartera óptima
   let optimalWallet: OptimalWallet = {
      apalancamiento: 2,
      bajista:false,
      capitalinicial: 100000,
      idcartera: 0,
      nombre: nombrecartera,
      valorLiquidativo: 100000,
      valorliquidativoTemp: 0.0,
      riesgomaximo: 50.0,
      tipocuenta: 'MARGEN',
      tiporiesgo: 'LIMITADO',
      riesgo: 1000.0,
      comisionbroker: 10.0,
      idmercado: 8,
      intervalotiempo: 6,
      prima: false,
      participacion: false,
      simulado: true,
      poderCompra: 200000,
      numeroReconfiguracion: 0,
      stopLoss: 20,
      profit: 10,
      capitales:[ 1000.0, 1000.0],
      fondosDisponibles: 100000,
      margen: 0,
      margenRequeridoPor: 30,
      controlMarginCall: 75.0,
      lista: 0,
      nOperaciones: 0,
      maxDiferenciaCierres: 0.0,
      rendimientoNeto: 0.0,
      rendimientomedioanual: 0.0,
      rendimientoacumuladoanual: 0.0,
      tasacrecimientoanualcompuesto: 0.0,
      periodosoperativa: 0,
      beneficioneto: 0.0,
      beneficionetoporcentual: 0.0,
      mayorretrocesodesdemaximo: 0.0,
      mayorretrocesodesdemaximoporcentual: 0.0,
      mediabeneficioperdidaporcentual: 0.0,
      sumaresiduosbeneficioperdidaporcentual: 0.0,
      volatilidadperiodo: 0.0,
      volatilidadanual: 0.0,
      mesesdd: 0,
      maximoretrocesoperiodo: 0.0,
      sumarrendimientosanuales: 0.0,
      prombeneficiointervalo: 0.0,
      prombeneficionintervaloporcentual: 0.0,
      sumatorio: false,
      coeficientevolatilidadanual: 1.0,
      ratiobeneficioriesgo: 0.0,
      modelodesde: '',
      efectivo: 100000.0,
      gastosGestionPor: 1.0,
      gastosPrestamoPor: 8.0,
      nRecalcular: 0,
      idModelo: 0,
      liquidativos: null,
      sincro: true,auto:false, 
      idCarteras:[0,0,0,0,0],
      subCarteras: '',
      chkgastogest:true,
      chkgastoprest:true,
      chkcomisionbroker:true
  }

    // Obtener el token de autenticación
    let auth_token = this._cookieService.get('auth_token');

    // Llamar al servicio para registrar la cartera
    this._sseservice.apiPostNew('registrarcartera', optimalWallet, auth_token).subscribe({
      next: (response) => {
        console.log('Cartera registrada:', response);
        if(response.idcartera > 0){
          this.toastr.success("Cartera registrada exitosamente");
          this._sseservice.apiPostNew('suscripciones/registrarGestorModelo', {idcartera: response.idcartera, idModelo: suscripcion.idmodelo, idmercado: suscripcion.idcartera, nombre:response.nombre, periodo: 6}, auth_token).subscribe({
            next: (data:any)=>{
              console.log(data);
              if(data.status){
                this.toastr.success('Cuenta relacionada a modelo');
                window.open('/gestor?idcartera='+response.idcartera, '_blank');
             }else{
                this.toastr.error('Error.');
            }
            }
          });
        } else {
          this._sseservice.apiPostNew('getCarteraByNombre', { nombre: nombrecartera }, auth_token).subscribe({
            next: (data:any)=>{
              this._sseservice.apiPostNew('suscripciones/registrarGestorModelo', {idcartera: data.cartera.idcartera, idModelo: suscripcion.idmodelo, idmercado: suscripcion.idcartera, nombre:data.cartera.nombre, periodo: 6}, auth_token).subscribe({
                next: (datat:any)=>{
                  console.log(datat);
                    window.open('/gestor?idcartera='+data.cartera.idcartera, '_blank');                  
                }
              });
            }
          });
        }
      },
      error: (err) => {
        console.error('Error al registrar la cartera:', err);
        this.toastr.error("Ocurrió un error al registrar la cartera");
      }
    });

    

  }else{
    this.suscripcionesService.eliminarSuscripcionGestor(suscripcion).subscribe({
      next: (value: Suscripcion) => {
        let sus = this.listaSuscripciones.find(
          (s) =>
            s.idcartera == suscripcion.idcartera &&
            s.idmodelo == suscripcion.idmodelo
        );
        if (sus) {
          sus.idsuscripcion = value.idsuscripcion;
        }
        this.toastr.success("Suscripción exitosa");
        this.cd.markForCheck();
      },
      error: (err) => {
        this.toastr.error("Ocurrió un error registrando la suscripción");
      },
    });
  }
}

  eliminarSuscripcion(suscripcion: Suscripcion) {
    this.suscripcionesService
      .eliminarSuscripcion(suscripcion.idsuscripcion)
      .subscribe({
        next: (value) => {
          let sus = this.listaSuscripciones.find(
            (s) =>
              s.idcartera == suscripcion.idcartera &&
              s.idmodelo == suscripcion.idmodelo
          );
          if (sus) {
            sus.idsuscripcion = 0;
          }
          this.toastr.success("Suscripción eliminada exitosamente");
          this.cd.markForCheck();
        },
        error: (err) => {
          this.toastr.error("Ocurrió un error eliminando la suscripcion");
        },
      });
  }

  cambiarHoraEntradaSalida(suscripcion: Suscripcion) {
    if (suscripcion.suscrito && suscripcion.idsuscripcion) {
      this.registrarSuscripcion(suscripcion);
    }
  }

  setAll(completed: boolean) {
    //this.allComplete = completed;
    if (this.listaSuscripciones == null) {
      return;
    }
    this.listaSuscripciones.forEach((t) => (t.suscrito = completed));
  }
  eliminar(suscripcion: Suscripcion){
    console.log(suscripcion);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '380px',
      height: '200px',
      panelClass: this.theme,
      data: {
        msj: '!Atención! La Cartera  será eliminada en todos los módulos del programa.'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('El diálogo se cerró');
      if (result) {
        const idcartera = {
          idcartera: Number(suscripcion.idcartera), //)
        };
        this._sseservice.apiPostNew('eliminarcartera',idcartera, this.licencia).subscribe(response =>{
          console.log(response);
          this.consultarSuscripciones();

        });
      } else {
      
        console.log('La acción fue cancelada');
      }
    });
  }
}
